
export interface ILanguageVariableList{
    id: number,
    variable: string,
    languages: string,
    defaultText: string
}
